import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faChevronDown, faSearch, faEraser } from '@fortawesome/free-solid-svg-icons';
import ComboBoxBusca from './ComboBoxBusca';

const rotuloExtensao = (ext) => {
  // Há extensões homônimas em estados diferentes (Campina Grande fica em PA
  // e em PB). Só o nome não permite escolher a certa.
  const local = [ext.cidade, ext.uf].filter(Boolean).join('/');
  return local ? `${ext.nome} — ${local}` : ext.nome;
};


/**
 * Filtros da listagem de protocolos.
 *
 * Colapsados por padrão e aplicados por botão, não a cada tecla digitada:
 * a secretaria já reclamou de listagem que recarrega no meio da digitação.
 */
const ProtocoloFilterBar = ({
  filtros,
  onChange,
  onAplicar,
  onLimpar,
  tipos = [],
  cursos = [],
  extensoes = []
}) => {
  const [aberto, setAberto] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onAplicar();
  };

  const campo =
    'w-full min-h-11 px-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400';

  return (
    <div className="mb-4 w-full max-w-full">
      <button
        type="button"
        onClick={() => setAberto(a => !a)}
        className="flex items-center gap-2 min-h-11 px-3 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-400"
        aria-expanded={aberto}
      >
        <FontAwesomeIcon icon={faFilter} />
        <span>Filtros</span>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`transition-transform duration-200 ${aberto ? 'rotate-180' : ''}`}
        />
      </button>

      {aberto && (
        <form
          onSubmit={handleSubmit}
          className="mt-3 bg-white rounded shadow p-3 sm:p-4 w-full max-w-full"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            <div>
              <label htmlFor="f-numero" className="block text-sm text-gray-700 mb-1">Número</label>
              <input
                id="f-numero" name="numero" type="number" inputMode="numeric"
                value={filtros.numero} onChange={onChange} className={campo} placeholder="Ex.: 4634"
              />
            </div>

            <div>
              <label htmlFor="f-requerente" className="block text-sm text-gray-700 mb-1">Requerente</label>
              <input
                id="f-requerente" name="requerente" type="text"
                value={filtros.requerente} onChange={onChange} className={campo} placeholder="Nome do requerente"
              />
            </div>

            <div>
              <label htmlFor="f-tipo" className="block text-sm text-gray-700 mb-1">Tipo</label>
              <select id="f-tipo" name="tipo" value={filtros.tipo} onChange={onChange} className={campo}>
                <option value="">Todos</option>
                {tipos.map(t => <option key={t.valor} value={t.valor}>{t.rotulo}</option>)}
              </select>
            </div>

            <div>
              <label htmlFor="f-curso" className="block text-sm text-gray-700 mb-1">Curso</label>
              <select id="f-curso" name="curso" value={filtros.curso} onChange={onChange} className={campo}>
                <option value="">Todos</option>
                {cursos.map(c => <option key={c.idCurso} value={c.idCurso}>{c.nome}</option>)}
              </select>
            </div>

            <div>
              <label htmlFor="f-extensao" className="block text-sm text-gray-700 mb-1">Extensão</label>
              <ComboBoxBusca
                id="f-extensao"
                name="extensao"
                value={filtros.extensao}
                onChange={(valor) => onChange({ target: { name: 'extensao', value: valor } })}
                opcoes={extensoes.map(e => ({ valor: e.idExtensao, rotulo: rotuloExtensao(e) }))}
                placeholder="Todas"
                placeholderBusca="Digite o nome da extensão..."
                textoVazio="Nenhuma extensão encontrada"
              />
            </div>

            <div>
              <label htmlFor="f-status" className="block text-sm text-gray-700 mb-1">Situação</label>
              <select id="f-status" name="status" value={filtros.status} onChange={onChange} className={campo}>
                <option value="">Todas</option>
                <option value="ATIVO">Ativo</option>
                <option value="ANULADO">Anulado</option>
              </select>
            </div>

            <div>
              <label htmlFor="f-dataInicio" className="block text-sm text-gray-700 mb-1">Entrada de</label>
              <input
                id="f-dataInicio" name="dataInicio" type="date"
                value={filtros.dataInicio} onChange={onChange} className={campo}
              />
            </div>

            <div>
              <label htmlFor="f-dataFim" className="block text-sm text-gray-700 mb-1">Entrada até</label>
              <input
                id="f-dataFim" name="dataFim" type="date"
                value={filtros.dataFim} onChange={onChange} className={campo}
              />
            </div>
          </div>

          <div className="mt-4 flex flex-col sm:flex-row gap-2">
            <button
              type="submit"
              className="min-h-11 px-4 py-2 rounded bg-green-600 text-white font-semibold shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 flex items-center justify-center gap-2"
            >
              <FontAwesomeIcon icon={faSearch} />
              <span>Aplicar filtros</span>
            </button>
            <button
              type="button"
              onClick={onLimpar}
              className="min-h-11 px-4 py-2 rounded border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400 flex items-center justify-center gap-2"
            >
              <FontAwesomeIcon icon={faEraser} />
              <span>Limpar</span>
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default ProtocoloFilterBar;
